<div class="filter-drop-down search-style w-100 -mat-select-height-unset -border-bottom-none" [ngClass]="{'-search-container' : pageType === 'monotainer'}">
  <mat-form-field appearance="outline">
    <span class="search-graph-container search-img">
      <img src="../.../../../../assets/images/search-idec.svg" alt="search" class="h-15 img-fluid">

      <input matInput [formControl]="search" autocomplete="off" [title]="placeHolder" [placeholder]="placeHolder" #titleInput>

      <button type="submit" *ngIf="search.value" class="people-search-btn" (click)="clearSearch()" title="Clear">
        &#x2715;
      </button>
    </span>
  </mat-form-field>
</div>